import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsService } from 'ngx-permissions';
import { FavouriteModel } from 'src/app/course/models/favourite.model';
import { FavouriteService } from 'src/app/course/services/favourite.service';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-favourite-button',
  templateUrl: './favourite-button.component.html',
  styleUrls: ['./favourite-button.component.scss']
})
export class FavouriteButtonComponent implements OnInit {
  @Input() courseId: number;
  @Input() courseTitle: string;
  favModel: FavouriteModel = {} as any;
  courseLink = environment.courseDetailsUrl;
  isAuth: boolean;
  copied: boolean = false;
  fav = false;
  IsAdmin: boolean;

  constructor(
    private favoriteService: FavouriteService,
    private authService: AuthService,
    private permissionService: NgxPermissionsService,
    private modalService: NgbModal) {
      this.permissionService.hasPermission('Admin').then((hasPermission) => {
        this.IsAdmin = hasPermission;
      });
  }

  ngOnInit(): void {
    this.courseLink = this.courseLink.concat(String(this.courseId));
    this.favModel.courseId = this.courseId;
    this.isAuth = this.authService.isAuthenticated();
    if (this.isAuth) {
      this.favoriteService.getCourseFav(this.favModel.courseId).subscribe((result: FavouriteModel) => {
        if (result) {
          this.favModel.id = result.id;
          this.fav = !this.fav;
        }
      });
    }


  }

  editFav() {
    if (this.isAuth) {
      this.favoriteService.updatStatus(this.favModel.courseId).subscribe((result: boolean) => {
        if (result) {
          this.fav = !this.fav;
        }
      });
    }
  }

  open(content: any) {
    this.copied = false;
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }

  copyLink(linkInput: any){
    linkInput.select();
    document.execCommand('copy');
    linkInput.setSelectionRange(0, 0);
    this.copied = true;
  }
}
